// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpButton } from 'components/DesignKit';

type Props = {
    open: boolean,
    setAgreementConfirmation: Function,
    setPartialPayment: Function,
}

const AgreementConfirmation = (props: Props) => {
  const { open, setAgreementConfirmation, setPartialPayment } = props;
  return (
    <Modal
      centered
      closable={false}
      visible={open}
      footer={[
        <SpButton onClick={() => { setPartialPayment(false); setAgreementConfirmation(false); }} type="secondary">Cancel</SpButton>,
        <SpButton onClick={() => { setPartialPayment(true); setAgreementConfirmation(false); }}>Agree</SpButton>,
      ]}
      title="Agreement"
    >
      <div className="px-4 pb-3">
        Please be aware of the State Laws, where you operate your business, before finalizing ‘Late Fee’, ‘Interest if Overdue’, and ‘Grace Period’.
        Swirepay cannot be held liable for any disputes that occur between Merchant and Customer over the terms of the contract
      </div>
    </Modal>
  );
};

export default AgreementConfirmation;
